<template>
 <div>
    
  
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>
  </el-row>

  <el-row class="ml-20 mr-20" v-if="!editMode">
      <el-col :xs="12" :sm="12" :lg="12">
        <el-button icon="el-icon-search" circle type="warning" @click="drawer = true"></el-button>
      </el-col>
      <el-col :xs="12" :sm="12" :lg="12" >
        <el-button type="primary" @click.prevent="createTodo" style="float: right;">新增 <i class="el-icon-circle-plus-outline"></i>
      </el-button>
      </el-col>
    </el-row>
  <el-row>


   

    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main>
        <el-table :data="tableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
          <el-table-column prop="title" label="標題" >
              <template slot-scope="scope">
                <router-link :to="`${scope.row.todoUrl}${scope.row.id}`">{{scope.row.title }}
                </router-link>
                <p>{{scope.row.reqPayNo}}</p>
              </template>
          </el-table-column>
          
          <el-table-column label="狀態" >
            <template slot-scope="scope">
              <el-tag :type="caseType(scope.row.status)">{{ scope.row.status | fmtSignResult}}</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-popconfirm
                  class="ml-10 popconfirm-bg"
                  title="確定刪除此筆資料嗎?"
                  confirm-button-text="確定"
                  cancel-button-text="取消刪除"
                  icon="el-iconf-info"
                  icon-color="red"
                  @confirm="handleDelete(scope.row.id)"
              >
              <el-button v-if="scope.row.status === 'draft'" type="danger" icon="el-icon-delete" circle slot="reference"></el-button>
                
              </el-popconfirm>
            </template>
          </el-table-column>
          
        </el-table>

        <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
          <el-pagination
              background
              layout="prev, pager, next"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              @current-change="handleCurrentChange">
          </el-pagination>
        </div>

      </el-main>
    </el-col>

    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    

    <el-drawer
        size="70%"
        title="搜尋"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">

        <el-select :xs="24" v-model="queryField" placeholder="選擇搜尋條件" style="padding: 0 0 0 10px">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-input v-model="keyword" style="width: 200px" placeholder="輸入關鍵字" class="ml-10 mt-10" suffix-icon="el-icon-search"></el-input>

        <el-button type="primary" @click.prevent="search" class="ml-10 mt-10">查詢</el-button>
        <el-button type="normal" @click.prevent="clearQuery" class="ml-10 mt-10">清除條件</el-button>


        

       
      </el-drawer>
  </el-row>

</div>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import request from "@/api/request";

export default {
  name: "ReqBuyMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }

    return {

      editMode: false,
      drawer: false,
      direction: 'ltr',


      dw: '60%',
      gridData: [],
      fileList: [],
      tableData: [],
      options: [{
        value: 'totalPrice',
        label: '請款金額大於'
      }],
      queryField: '',
      keyword: '',
      pageNum: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      formLabelWidth: '',
      buyTypeOption: [],
      form: {
        submitBy: this.$store.state.login.userInfo.id,
        buyType: '',
        price: 0,
        description: '',
        attachmentUuid: '',
        attachmentName: '',

        form:'',
        startDate:'',
        status: 'draft',
        todoType: 'req_buy'
      },
      signForm: {
        buyId: 0,
        submitBy: this.$store.state.login.userInfo.id,
        notes: ''
      },
      signFormVisible: false,

      roles: [],
      rules: {
        buyType: [{validator: checkName, trigger: 'change'}],
        price: [{validator: checkName, trigger: 'change'}],
        description: [{validator: checkName, trigger: 'change'}]
      }
    }
  },
  methods: {
    handleClose(){
      this.drawer = false
    },
    createTodo(){
      this.form.title = "請購單"
      this.form.startDate = new Date()
      this.request.post("/todo", this.form).then(res => {
        if (res.code === '200') {
          this.$router.push(res.data.todoUrl + res.data.id)
        }
      })
    },
    search() {
      this.loadData()
    },
    loadType() {
      let req = '/dic/type?queryField=apply_buy'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.buyTypeOption = res.data
        }
      })
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loadData()
    },
    clearQuery() {
      this.keyword = ''
      this.queryField = ''
      this.loadData()
    },

    /** data crud **/
   loadData() {
      
      let {pageNum, pageSize, queryField, keyword} = this

      let url = "/req-buy/my?pageNum=" + pageNum + "&pageSize=" + pageSize + "&queryField=" + queryField + "&keyword=" + keyword
      this.request.get(url).then(res => {
          if (res.code === '200') {
            this.drawer = false

            this.tableData = res.data.records
            this.total = res.data.total

            
          } else {
            this.showResult('error', "資料取得失敗")
          }
        })

    },
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('this.form:', this.form)
        if (valid) {
          try {
            await this.$store.dispatch('reqBuy/saveReqBuy', this.form)

            this.showResult('success', '資料更新成功.')

            await this.loadData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.id = null
    },
    handleEdit(rowData) {
      this.dialogFormVisible = true
      this.form = rowData
    },
    async handleDelete(id) {
      try {
        await this.$store.dispatch('reqBuy/deleteReqBuy', id)
        this.showResult('success', '資料刪除成功.')

        await this.loadData()
        this.dialogFormVisible = false

      } catch (e) {
        this.showResult('error', '資料刪除失敗.')
      }
    },
    handleSignoff(row) {
      this.signForm.buyId = row.id
      this.signForm.notes = ''
      this.signFormVisible = true
    },
    closeDialog() {
      this.$refs['dataForm'].resetFields()
      this.loadData()
    },
    exportData() {
      window.open(process.env.VUE_APP_API_SERVER + '/product/export', "new")
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },
    handleUploadSuccess(res, file) {
      this.dialogImportFormVisible = false
      this.form.attachmentUuid = res.uuid
      this.form.attachmentName = res.fileName
      console.log(res)
      // if (res !== '') {
      //   this.request.get("/file/list/" + res).then(res1 => {
      //    this.form.attachment = res1.data[0].url
      //   })
      // } else {
      //   this.showResult('error', res.message)
      // }
    },
    async submitSignForm(rowData) {
      // console.log(this.signForm)
      this.signFormVisible = false
      try {
        await this.$store.dispatch('reqBuy/submitSignForm', this.signForm)
        this.showResult('success', '簽核送出成功')

        await this.loadData()

      } catch (e) {
        this.showResult('error', e.message)
      }
    },

    caseType(status) {
      if (status === '草稿') return ''
      if (status === '簽核中') return 'warning'
      if (status === '退回') return 'danger'
      if (status === '完成') return 'success'
      if (status === 'invalid') return 'danger'
    },
    async signoffHistory(row) {
      console.log('row:', row.id)
      try {
        let result = await this.$store.dispatch('reqBuy/getSignOffHistory', row.id)
        this.gridData = result.data.records

      } catch (e) {
        this.showResult('error', e.message)
      }
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = '60%'
      }
    }

  },
  mounted() {
    this.loadData()
    this.loadType()
    window.onresize = () => {
      return (() => {
        this.setDialogWidth();
      })();
    };
    console.log(this.$store.state.login.userInfo)
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}

.myform >>> .el-form-item__label {
  padding: 0;
}
.mymain {
  padding: 20px 4px;
}
.mytable {
  padding: 10px;
}
.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 8px;
}

.taskMain >>> .el-card__body {
  padding: 0;
}
.el-table {
  padding: 0;
}


</style>
